import { NextQuery } from '@empathy/search-types';
import { QuerySignalsState } from '../../../models';
import { isArrayEmptyOrNull } from '../../../utils';
import { QUERY_SIGNALS_GETTERS_KEYS } from '../query-signals.const';
import { QuerySignalsGetter } from '../query-signals.interfaces';

export class NextQueriesWithResultsGetter implements QuerySignalsGetter {
  getters = {
    [QUERY_SIGNALS_GETTERS_KEYS.nextQueriesWithResults]: (querySignalsState: QuerySignalsState, getters: any): NextQuery[] =>
        (getters[QUERY_SIGNALS_GETTERS_KEYS.nextQueries] as NextQuery[]).filter(nextQuery => !isArrayEmptyOrNull(nextQuery.results))
  };
}
